"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Kind = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _ui = require("../ui");
var _DateTime = require("./DateTime");
var _Status = require("./Status");
var _Type = require("./Type");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TertiaryShadeText = (0, _styledComponents.default)(_ui.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var Kind = function Kind(_ref2) {
  var id = _ref2.id,
    status = _ref2.status,
    ticker = _ref2.ticker,
    type = _ref2.type,
    dateMillis = _ref2.dateMillis,
    statusDotColor = _ref2.statusDotColor,
    internal = _ref2.internal,
    betweenAccounts = _ref2.betweenAccounts,
    fiat = _ref2.fiat,
    invoiceId = _ref2.invoiceId,
    overPaid = _ref2.overPaid,
    fullyPaid = _ref2.fullyPaid,
    paidAmount = _ref2.paidAmount,
    target = _ref2.target,
    className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center  ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_Status.Status, {
    id: id,
    dotProps: {
      color: statusDotColor[status]
    },
    status: status,
    ticker: ticker,
    target: target,
    className: "mb-1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ms-3"
  }, /*#__PURE__*/_react.default.createElement(_ui.H6, null, /*#__PURE__*/_react.default.createElement(_Type.Type, {
    betweenAccounts: betweenAccounts,
    internal: internal,
    type: type,
    fiat: fiat,
    invoiceId: invoiceId,
    overPaid: overPaid,
    fullyPaid: fullyPaid,
    paidAmount: paidAmount
  })), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, /*#__PURE__*/_react.default.createElement(_DateTime.DateTime, {
    millis: dateMillis
  }))));
};
exports.Kind = Kind;